// @flow
import { format, parse, isValid, toDate, parseISO } from "date-fns";

const dateFnsFormat = "M/d/yyyy";

export const coerceToDate = (value: mixed): ?Date => {
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === "string" && value) {
    const isoParsed = toDate(parseISO(value));
    if (isValid(isoParsed)) {
      return isoParsed;
    }

    const formattedParsed = parse(value, dateFnsFormat, new Date());
    if (isValid(formattedParsed)) {
      return formattedParsed;
    }
  }

  return null;
};

export const combineDateAndTime = (date: Date, time: Date): string => {
  const dateFormat = "yyyy-MM-dd";
  const timeFormat = "HH:mm:ss";

  return `${format(date, dateFormat)} ${format(time, timeFormat)}`;
};

export const toDateTime = (dateValue: mixed, timeValue: mixed): Date => {
  const date = coerceToDate(dateValue);
  const time = coerceToDate(timeValue);

  if (!date || !time) {
    return new Date(NaN);
  }

  const result = new Date(date);
  result.setHours(time.getHours(), time.getMinutes(), 0, 0);
  return result;
};
